export default __webpack_public_path__ + "static/media/001-W-celibataire.c2e54767.svg";